module.exports = __webpack_public_path__ + "static/media/Btn-Chevron-Red-Left.84ac6643.svg";